import { render, staticRenderFns } from "./defaultPage.vue?vue&type=template&id=6ce5d564"
import script from "./defaultPage.vue?vue&type=script&lang=js"
export * from "./defaultPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports